import * as React from 'react';
import {Draggable} from 'react-beautiful-dnd';

import type {SalesAutomationItemType} from '../../../../sales-automation/types';

import {SalesAutomationCard} from './sales-automation-card';

type Props = {
    parentId: string;
    type: SalesAutomationItemType;
    entityId: string;
    index: number;
    isHidden?: boolean;
    isDragDisabled?: boolean;
    children?: React.ReactNode;
};

/*
 * Root component for any item currently applied to a sales process.
 *
 * This defers to the individual types' components for the actual rendering
 * of the cards.
 */
export class SalesAutomationDraggableCard extends React.PureComponent<Props> {
    render() {
        return (
            // disableInteractiveElementBlocking is set so that the card,
            // which is essentially a `button` can be dragged as well as clicked on.
            // Spacebar will pick to drag, enter will "click" to edit
            <Draggable
                disableInteractiveElementBlocking={true}
                draggableId={this.props.entityId}
                isDragDisabled={this.props.isDragDisabled}
                index={this.props.index}
            >
                {(provided) => (
                    <SalesAutomationCard
                        parentId={this.props.parentId}
                        type={this.props.type}
                        entityId={this.props.entityId}
                        draggableProps={provided.draggableProps}
                        dragHandleProps={provided.dragHandleProps}
                        getDraggableRef={provided.innerRef}
                        isHidden={this.props.isHidden}
                    >
                        {this.props.children}
                    </SalesAutomationCard>
                )}
            </Draggable>
        );
    }
}
